import { getConnectionApplicationStatusBadgeColour } from '@/helpers/connectionApplications';
import { Badge, Card, Conditional, Field, Text } from '@payaca/ambrosia';

import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';
interface DnoResponseCardProps {
  status: Nullish<string>;
  connectionApplicationStatus?: Nullish<string>;
  dnoComments?: Nullish<string>;
  dnoWorksRequiredReasons?: Nullish<string[]>;
}

const DnoResponseCard: FC<DnoResponseCardProps> = (props) => {
  const {
    status,
    dnoComments,
    connectionApplicationStatus,
    dnoWorksRequiredReasons,
  } = props;
  return (
    <>
      <Card>
        <Card.Body>
          <div className="flex gap-3 justify-between">
            <h3>DNO Response</h3>
            <Badge
              colour={getConnectionApplicationStatusBadgeColour(
                status || undefined
              )}
              variant="soft"
              className="capitalize"
            >
              {status}
              {connectionApplicationStatus &&
                ` (${connectionApplicationStatus})`}
            </Badge>
          </div>

          <Conditional condition={!!status}>
            <Field.Legacy className="mb-4 mt-4">
              <Field.Label>DNO Comments</Field.Label>
              <p className={!dnoComments ? 'text-gray-400' : ''}>
                {dnoComments ?? 'No comments'}
              </p>
            </Field.Legacy>
          </Conditional>

          <Conditional condition={!!dnoWorksRequiredReasons?.length}>
            <Field.Legacy className="mb-4">
              <Field.Label>DNO works required</Field.Label>
              <ul className="mt-1 list-disc pl-4">
                {dnoWorksRequiredReasons?.map((reason, idx) => (
                  <li key={idx}>
                    <Text as="div">{reason}</Text>
                  </li>
                ))}
              </ul>
            </Field.Legacy>
          </Conditional>
        </Card.Body>
      </Card>
      <hr className="mt-4" />
    </>
  );
};

export default DnoResponseCard;
